"use client";
import React from 'react';
import { FaReact, FaCube, FaPython, FaBrain, FaAws, FaDocker, FaNode } from 'react-icons/fa';
import { SiFlutter, SiTypescript, SiMongodb, SiPostgresql, SiGraphql } from 'react-icons/si';

const TechStack = () => {
  const technologies = [
    { icon: FaReact, name: "React", color: "text-[#61DAFB]" },
    { icon: FaCube, name: "Next.js", color: "text-white" },
    { icon: SiTypescript, name: "TypeScript", color: "text-[#3178C6]" },
    { icon: FaPython, name: "Python", color: "text-[#3776AB]" },
    { icon: FaBrain, name: "TensorFlow", color: "text-[#FF6F00]" },
    { icon: FaAws, name: "AWS", color: "text-[#FF9900]" },
    { icon: FaDocker, name: "Docker", color: "text-[#2496ED]" },
    { icon: SiFlutter, name: "Flutter", color: "text-[#02569B]" },
    { icon: FaNode, name: "Node.js", color: "text-[#339933]" },
    { icon: SiMongodb, name: "MongoDB", color: "text-[#47A248]" },
    { icon: SiPostgresql, name: "PostgreSQL", color: "text-[#4169E1]" },
    { icon: SiGraphql, name: "GraphQL", color: "text-[#E10098]" },
  ];

  return (
    <div className="relative py-16 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-transparent"></div>
      <div className="absolute inset-0 bg-grid opacity-10"></div>

      {/* Section Header */}
      <div className="text-center mb-12 relative z-10">
        <span className="text-kuttos-cyan text-sm font-semibold tracking-widest uppercase mb-2 block">Technology Stack</span>
        <h2 className="font-display text-2xl md:text-3xl font-bold text-white">Powered by Industry Leaders</h2>
      </div>

      {/* Infinite Scrolling Container */}
      <div className="relative">
        {/* Gradient Overlays for seamless effect */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#030305] to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#030305] to-transparent z-10 pointer-events-none"></div>

        {/* Scrolling Track */}
        <div className="flex overflow-hidden">
          <div className="flex animate-marquee gap-6">
            {/* First Set */}
            {technologies.map((tech, i) => (
              <div
                key={`set1-${i}`}
                className="flex-shrink-0 group"
              >
                <div className="relative w-40 h-32 bg-gradient-to-br from-gray-900/80 to-black/80 backdrop-blur-sm border border-gray-800/50 rounded-xl p-6 hover:border-kuttos-cyan/50 transition-all duration-300 hover:scale-105">
                  {/* Glow effect on hover */}
                  <div className="absolute inset-0 bg-gradient-to-br from-kuttos-cyan/0 to-kuttos-blue/0 group-hover:from-kuttos-cyan/5 group-hover:to-kuttos-blue/5 rounded-xl transition-all duration-300"></div>
                  
                  {/* Content */}
                  <div className="relative flex flex-col items-center justify-center h-full">
                    <tech.icon className={`text-4xl mb-3 ${tech.color} transition-transform group-hover:scale-110 duration-300`} />
                    <span className="text-white text-sm font-semibold text-center">{tech.name}</span>
                  </div>

                  {/* Corner accent */}
                  <div className="absolute top-2 right-2 w-1 h-1 bg-kuttos-cyan/30 rounded-full group-hover:bg-kuttos-cyan group-hover:shadow-[0_0_8px_rgba(0,243,255,0.6)] transition-all duration-300"></div>
                </div>
              </div>
            ))}

            {/* Second Set (duplicate for seamless loop) */}
            {technologies.map((tech, i) => (
              <div
                key={`set2-${i}`}
                className="flex-shrink-0 group"
              >
                <div className="relative w-40 h-32 bg-gradient-to-br from-gray-900/80 to-black/80 backdrop-blur-sm border border-gray-800/50 rounded-xl p-6 hover:border-kuttos-cyan/50 transition-all duration-300 hover:scale-105">
                  <div className="absolute inset-0 bg-gradient-to-br from-kuttos-cyan/0 to-kuttos-blue/0 group-hover:from-kuttos-cyan/5 group-hover:to-kuttos-blue/5 rounded-xl transition-all duration-300"></div>
                  
                  <div className="relative flex flex-col items-center justify-center h-full">
                    <tech.icon className={`text-4xl mb-3 ${tech.color} transition-transform group-hover:scale-110 duration-300`} />
                    <span className="text-white text-sm font-semibold text-center">{tech.name}</span>
                  </div>

                  <div className="absolute top-2 right-2 w-1 h-1 bg-kuttos-cyan/30 rounded-full group-hover:bg-kuttos-cyan group-hover:shadow-[0_0_8px_rgba(0,243,255,0.6)] transition-all duration-300"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom text */}
      <div className="text-center mt-8 relative z-10">
        <p className="text-gray-500 text-sm">And many more cutting-edge technologies</p>
      </div>
    </div>
  );
};

export default TechStack;
